import React from 'react'
import PropTypes from 'prop-types'
import { DetailsTimelineChart, timelineIcons } from '@/components/charts'
import { Definition, Term } from '../common/Details'
import { Box, Text } from '@maui/elements'

const noDataAvailable = 'No data available'

const Tooltip = (item) => {
  const { point: { data } } = item

  if (data?.endDate) return null

  const date = new Date(data.xFormatted)
  const formattedDate = date.toLocaleDateString([], { month: 'long', day: 'numeric', year: 'numeric' })
  return (
    <Box>
      <Box
        width='100%'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        background='colorBrandingMandiantRed'
        color='colorTextEmphasis'
        padding='8px 8px 6px 8px'
        zIndex='100000'
        gap='4px'
        borderRadius='4px'
      >
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" gap="4px">
          <Text
            fontWeight='700'
            fontSize='12px'
            textAlign='center'
            whiteSpace='nowrap'
          >{data.text}</Text>
          <Text
            fontWeight='700'
            fontSize='12px'
            textAlign='center'
            whiteSpace='nowrap'
          >{data.status}</Text>
        </Box>
        <Text fontWeight='400' fontSize='12px'>{formattedDate}</Text>
      </Box>
      <Box
        width='0'
        height='0'
        marginLeft='calc(50% - 10px)'
        borderLeft='10px solid transparent'
        borderRight='10px solid transparent'
        borderTopColor='colorBrandingMandiantRed'
        borderTopWidth='10px'
        borderTopStyle='solid'
        fontSize='0'
        lineHeight='0'
      ></Box>
    </Box>
  )
}

const PointSymbol = (e) => {
  const { datum: { status, endDate } } = e
  if (endDate) return null

  const knownType = Object.keys(timelineIcons).includes(status)

  const circleBaseRadius = 12
  const { d, transform } = timelineIcons[knownType ? status : 'other']

  return (
    <>
      <Box as="circle" cx="0" cy="0" r={circleBaseRadius} fill='colorBrandingMandiantRed' />
      <Box as="path" d={d} transform={transform} fill='colorActionSecondaryHover' />
    </>
  )
}

export function ActorTimeline({ actorAncestryData }) {
  if (actorAncestryData === undefined) return null

  if (actorAncestryData === null) {
    return (
      <>
        <Term display='inline-flex'>Ancestry <br /> Timeline</Term>
        <Definition>{noDataAvailable}</Definition>
      </>
    )
  }

  const { history = [], suspectedGroups = [] } = actorAncestryData

  const formatDate = (date) => {
    return (new Date(date))
  }
  const formatTimelineData = (data) => {
    const newData = []
    data.history.forEach((d, index) => {
      if (history) {
        newData.push({
          category: '',
          x: formatDate(new Date(d.merged)),
          y: 0,
          text: d.name,
          status: 'Merged',
        })
      }
    })

    data.suspectedGroups.forEach((suspectedGroup, index) => {
      if (suspectedGroup) {
        return newData.push({
          category: '',
          x: formatDate(new Date(suspectedGroup.applied)),
          y: 0,
          text: suspectedGroup.name,
          status: 'Suspected',
        })
      }
    })
    return newData.sort((a, b) => new Date(a.x) - new Date(b.x))
  }

  const data = formatTimelineData(actorAncestryData)
  const chartData = [
    { id: 'AncestryTimeline', data },
    { id: 'PresentDay', data: [{ x: new Date(), y: 0, endDate: true }] },
  ]

  return (
    <Box display="flex" justifyContent="space-between" width="100%" mt="-20px">
      <Term>
        Ancestry <br /> Timeline
      </Term>
      {(!!history?.length || !!suspectedGroups?.length)
        ? (
          <Definition marginBottom='50px' display="inline-grid">
            <DetailsTimelineChart
            data={chartData}
            handlePointClick={() => null}
            tooltip={Tooltip}
            pointSymbol={PointSymbol}
            firstDate={new Date(data[0].x)}
            lastDate={new Date()}
            theme={{
              textColor: 'var(--maui-color-text-deemphasis)',
              axis: {
                ticks: {
                  text: {
                    fontSize: 8,
                    lineHeight: 16,
                    fontWeight: 700,
                    letterSpacing: 1.5,
                  },
                },
              },
              grid: {
                line: {
                  stroke: '#94000F',
                  strokeWidth: 4
                },
              },
            }}
            />
          </Definition>
          )
        : <Definition mb="10px">{noDataAvailable}</Definition>
       }
    </Box>
  )
}

ActorTimeline.propTypes = {
  actorAncestryData: PropTypes.shape({
    history: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
    suspectedGroups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
  }),
}

export default ActorTimeline
